import { createFileRoute } from '@tanstack/react-router'

import { NovaSenha } from '@/components/gestor/recuperacao/NovaSenha'

/*
 * `/gestor/nova-senha`: tela pública (sem sessão), aberta pelo link do e-mail ou pela entrada.
 * A guarda da rota-mãe a deixa abrir por estar na lista de caminhos públicos.
 */
export const Route = createFileRoute('/gestor/nova-senha')({ component: NovaSenha })
